import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Table
} from 'reactstrap';
import Loader from 'commonComponents/Loader';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLibraryList } from './redux/dispatcher';
import { SUPER_ADMIN_USER_MANUAL } from 'utils/pdfList';
import { ENTERPRISE_ADMIN_USER_MANUAL } from 'utils/pdfList';
import { COMPANY_ADMIN_USER_MANUAL } from 'utils/pdfList';
import AddLibrary from './AddLibrary';
import DeleteModel from './DeleteLibrary';

const Library = () => {
  const dispatch = useDispatch();
  const libraryList = useSelector((state) => state?.libraryReducer?.data || [])
  const isLoading = useSelector((state) => state?.libraryReducer?.isLoading);
  const [loginUserType, setLoginUserType] = useState(useSelector((state) => state.authReducer).data?.user?.role)
  const [modal, setModal] = useState(false);
  const [isDeleteModelShow, setIsDeleteModelShow] = useState(false)
  const [deleteLibraryId, setDeleteLibararyId] = useState('')
  const toggle = () => setModal(!modal);

  useEffect(() => {
    dispatch(fetchLibraryList())
  }, [dispatch]);

  const handleDownload = (url) => {
    try {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank"; // Open in new tab
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      toast.error('OOPS! Something went wrong');
    }
  };


  return (
    <>
      {
        isDeleteModelShow && (
          <DeleteModel libraryId={deleteLibraryId} setIsDeleteModelShow={setIsDeleteModelShow} />
        )
      }
      {isLoading ? <Loader /> :
        <Container fluid className="mt-4">
          <Card className="bg-secondary shadow w-100" style={{ border: 'none' }}>
            <CardHeader className="bg-white border-0 d-flex justify-content-between ">
              <h3 className="mb-0 text-center">Common Library</h3>
              {loginUserType === 'super_admin' && (
                <>
                  <AddLibrary modal={modal} toggle={toggle} />
                </>
              )
              }
            </CardHeader>
            <CardBody style={{ maxHeight: '700px', overflowY: 'auto', backgroundColor: '#f8f9fe' }}>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col" style={{ background: 'none' }}>File Name</th>
                    <th scope="col" className="text-right" style={{ background: 'none' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loginUserType === 'super_admin' && (
                    <>
                      <tr >
                        <td>USER MANUAL - SUPER ADMIN</td>
                        <td className="text-right">
                          <Button className="btn-primary" onClick={() => handleDownload(SUPER_ADMIN_USER_MANUAL)}>
                            <i className="fa-solid fa-cloud-arrow-down mr-1"></i> Download
                          </Button>

                          <Button color="danger" disabled={true}>
                            <i class="fa-solid fa-trash"></i>
                          </Button>


                        </td>
                      </tr>
                    </>
                  )}
                  {loginUserType === 'enterprise_admin' && (
                    <>
                      <tr >
                        <td>USER MANUAL - ENTERPRISE ADMIN</td>
                        <td className="text-right">
                          <Button className="btn-primary" onClick={() => handleDownload(ENTERPRISE_ADMIN_USER_MANUAL)}>
                            <i className="fa-solid fa-cloud-arrow-down mr-1"></i> Download
                          </Button>
                        </td>
                      </tr>
                    </>
                  )}
                  {loginUserType === 'company_admin' && (
                    <>
                      <tr >
                        <td>USER MANUAL - COMPANY ADMIN</td>
                        <td className="text-right">
                          <Button className="btn-primary" onClick={() => handleDownload(COMPANY_ADMIN_USER_MANUAL)}>
                            <i className="fa-solid fa-cloud-arrow-down mr-1"></i> Download
                          </Button>
                        </td>
                      </tr>
                    </>
                  )}
                  {
                    libraryList.map((library) => (
                      <tr key={library?.id}>
                        <td>{library?.file_name}</td>
                        <td className="text-right">
                          <Button className="btn-primary" onClick={() => handleDownload(library?.file_path)}>
                            <i className="fa-solid fa-cloud-arrow-down mr-1"></i> Download
                          </Button>

                          {loginUserType === 'super_admin' && (
                            <>
                              <Button color="danger" onClick={() => {
                                setDeleteLibararyId(library?.id);
                                setIsDeleteModelShow(true)
                              }}>
                                <i class="fa-solid fa-trash"></i>
                              </Button>
                            </>
                          )}

                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Container>
      }
    </>
  );
};

export default Library;
